import { DEVICE_TYPE } from "./enums";

var averageLevel = null;

/**
 * Get normalized audio level to display
 * @param {Number} inputAudioLevel
 * @return {number}
 */
function getNormalizedAudioLevel(inputAudioLevel) {
  const AVERAGE_LEVEL_PERCENTAGE = 0.7;

  if (averageLevel === null || averageLevel <= inputAudioLevel) {
    averageLevel = inputAudioLevel;
  } else {
    averageLevel = AVERAGE_LEVEL_PERCENTAGE * averageLevel + (1 - AVERAGE_LEVEL_PERCENTAGE) * inputAudioLevel;
  }

  // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
  let logLevel = Math.log(averageLevel) / Math.LN10 / 1.5 + 1;
  return Math.min(Math.max(logLevel, 0), 1);
}

/**
 * Get OT publisher source update method for given device type
 * @param {String} deviceType
 * @return {string}
 */
function getDeviceUpdateMethod(deviceType) {
  switch (deviceType) {
    case DEVICE_TYPE.AUDIO:
      return "setAudioSource";
    case DEVICE_TYPE.VIDEO:
      return "setVideoSource";
    default:
      throw new Error("Unknown device type!");
  }
}

/**
 * Build selected device key for store
 * @param {String} deviceType
 * @returns {String}
 * @private
 */
function _buildDeviceStoreKey(deviceType) {
  return `ev:${deviceType}Default`;
}

/**
 * Get selected device ID from storage or default
 * @param {Object[]} devices
 * @param {String} deviceType
 * @returns {string|null}
 */
function getDefaultDeviceID(devices, deviceType) {
  if (!devices.length) return null;
  const savedDeviceID = localStorage.getItem(_buildDeviceStoreKey(deviceType));
  const defaultDevice = devices.find(device => device.deviceId === savedDeviceID);
  return defaultDevice ? defaultDevice.deviceId : devices[0].deviceId;
}

/**
 * Set selected device ID to store
 * @param {String} deviceId
 * @param {String} deviceType
 */
function setDefaultDeviceID(deviceId, deviceType) {
  localStorage.setItem(_buildDeviceStoreKey(deviceType), deviceId);
}

export { getNormalizedAudioLevel, getDeviceUpdateMethod, getDefaultDeviceID, setDefaultDeviceID };
